import React from 'react';
import {useSelector} from "react-redux";

import Row from './Row';

export default function () {
    const items = useSelector(state => state.roles);

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                <tr className="text-center">
                    <th scope="col">Role Name</th>
                    <th scope="col">Actions</th>
                </tr>
                </thead>
                <tbody>
                {items.map(item => <Row key={item.id} item={item}/>)}
                </tbody>
            </table>
        </div>
    );
};
